var map = {
	"./ar": "8JKc",
	"./ar.js": "8JKc",
	"./az": "NBn6",
	"./az.js": "NBn6",
	"./bn": "QMG5",
	"./bn.js": "QMG5",
	"./cs": "ccKC",
	"./cs.js": "ccKC",
	"./de": "hmq6",
	"./de.js": "hmq6",
	"./el": "GjdS",
	"./el.js": "GjdS",
	"./es": "PgaD",
	"./es.js": "PgaD",
	"./fa": "mgj3",
	"./fa.js": "mgj3",
	"./fr": "AwQ3",
	"./fr.js": "AwQ3",
	"./hi": "CvLh",
	"./hi.js": "CvLh",
	"./hu": "0//c",
	"./hu.js": "0//c",
	"./id": "cQcj",
	"./id.js": "cQcj",
	"./it": "LqW+",
	"./it.js": "LqW+",
	"./ja": "vdmi",
	"./ja.js": "vdmi",
	"./jv": "XJyg",
	"./jv.js": "XJyg",
	"./ko": "AWD4",
	"./ko.js": "AWD4",
	"./my": "sPih",
	"./my.js": "sPih",
	"./nl": "LEeJ",
	"./nl.js": "LEeJ",
	"./pa-in": "3VIm",
	"./pa-in.js": "3VIm",
	"./pl": "37Ng",
	"./pl.js": "37Ng",
	"./pt": "XusE",
	"./pt.js": "XusE",
	"./ro": "1JQ6",
	"./ro.js": "1JQ6",
	"./ru": "5+z4",
	"./ru.js": "5+z4",
	"./sr": "VQGH",
	"./sr.js": "VQGH",
	"./th": "irgP",
	"./th.js": "irgP",
	"./tr": "KPV/",
	"./tr.js": "KPV/",
	"./uk": "t7V5",
	"./uk.js": "t7V5",
	"./uz": "EnEC",
	"./uz.js": "EnEC",
	"./vi": "WHlD",
	"./vi.js": "WHlD",
	"./zh-cn": "HUNL",
	"./zh-cn.js": "HUNL",
	"./zh-tw": "bnb+",
	"./zh-tw.js": "bnb+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vQf7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-and-time/locale ^\.\/.*$
// module id = vQf7
// module chunks = 1